import { apiRequest } from "../../index";

export const addRoom = async (roomData) => {
  return apiRequest("/api/owner/hotel-management/rooms", "POST", roomData, true);
};

export const getRoomsByHotelId = async (hotelId) => {
  return apiRequest(`/api/owner/hotel-management/rooms/${hotelId}`, "GET");
};

export const getRoomById = async ({ hotelId, page, limit, search, status, verificationStatus }) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  
  if (search) {
    params.append("search", search);
  }
  
  if (status) {
    params.append("status", status);
  }
  
  if (verificationStatus) {
    params.append("verificationStatus", verificationStatus);
  }
  
  return apiRequest(`/api/owner/hotel-management/rooms/${hotelId}?${params.toString()}`, "GET");
};

export const updateRoom = async (roomId, roomData) => {
  return apiRequest(`/api/owner/hotel-management/rooms/${roomId}`, "PUT", roomData, true);
};

export const deleteRoom = async (roomId) => {
  return apiRequest(`/api/owner/hotel-management/rooms/${roomId}`, "DELETE");
};

export const getAllHotels = async ({ hasRestaurant, limit }) => {
  const params = new URLSearchParams();
  if (hasRestaurant) params.append("hasRestaurant", hasRestaurant);
  if (limit) params.append("limit", limit.toString());

  return apiRequest(`/api/owner/hotel-management/listing/all?${params.toString()}`, "GET");
}

export const getAllOwnerHotel = async (status) => {
  return apiRequest(`/api/owner/hotel-management/rooms/6822dda69be3498e70ab0891?status=${status}`, "GET");
}